import React from 'react';
import { X, Download, Calendar } from 'lucide-react';
import { ModuleId } from '../../types/secondaryModule';
import { Shield, LineChart, Heart, Brain, Users } from 'lucide-react';
interface SecondaryModuleContainerProps {
  moduleId: ModuleId;
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}
const moduleConfigs = {
  safety: {
    title: '平安校园',
    agentRole: '易教·守护',
    subtitle: '全域感知 · 智能预警 · 精准干预',
    icon: Shield,
    color: '#38BDF8'
  },
  classroom: {
    title: '课堂洞察',
    agentRole: '易教·慧眼',
    subtitle: '精准观测 · 智能分析 · 持续优化',
    icon: LineChart,
    color: '#38BDF8'
  },
  growth: {
    title: '成长关怀',
    agentRole: '易教·关爱',
    subtitle: '全程陪伴 · 精准识别 · 温暖守护',
    icon: Heart,
    color: '#F472B6'
  },
  knowledge: {
    title: '智能批改',
    agentRole: '易教·助教',
    subtitle: '智能诊断 · 精准施策 · 效果追踪',
    icon: Brain,
    color: '#38BDF8'
  },
  'ai-tutor': {
    title: '智慧伴学',
    agentRole: '易教·伴学',
    subtitle: '全程陪伴 · 智能引导 · 个性成长',
    icon: Users,
    color: '#A78BFA'
  }
};
export function SecondaryModuleContainer({
  moduleId,
  isOpen,
  onClose,
  children
}: SecondaryModuleContainerProps) {
  const config = moduleConfigs[moduleId];
  const Icon = config.icon;
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center" data-id="element-419">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-420" />

      {/* Modal Content */}
      <div className="relative w-[95vw] h-[90vh] glass-panel rounded-2xl overflow-hidden border-2 border-[#0EA5E9]/30 shadow-[0_0_60px_rgba(14,165,233,0.3)]" data-id="element-421">
        {/* Header */}
        <div className="flex items-center justify-between border-b border-[#0EA5E9]/20 px-8 py-6 bg-gradient-to-r from-[#0B1120] to-transparent" data-id="element-422">
          {/* Left: Module Identity */}
          <div className="flex items-center gap-4" data-id="element-423">
            <div className="p-3 rounded-xl bg-white/5 border border-white/10" data-id="element-424">
              <Icon className="w-8 h-8" style={{
              color: config.color
            }} data-id="element-425" />
            </div>
            <div data-id="element-426">
              <h2 className="text-2xl font-bold text-white mb-1" data-id="element-427">
                {config.agentRole} {config.title}
              </h2>
              <p className="text-sm text-gray-400" data-id="element-428">{config.subtitle}</p>
            </div>
          </div>

          {/* Right: Actions */}
          <div className="flex items-center gap-4" data-id="element-429">
            <select className="glass-panel px-4 py-2 rounded-lg text-white text-sm border border-white/10 focus:outline-none focus:border-[#0EA5E9]/50" data-id="element-430">
              <option data-id="element-431">本周</option>
              <option data-id="element-432">本月</option>
              <option data-id="element-433">本学期</option>
              <option data-id="element-434">本学年</option>
            </select>
            <button className="flex items-center gap-2 glass-panel px-4 py-2 rounded-lg hover:bg-white/10 text-white text-sm border border-white/10 transition-colors" data-id="element-435">
              <Download className="w-4 h-4" data-id="element-436" />
              导出报告
            </button>
            <button onClick={onClose} className="p-2 glass-panel rounded-lg hover:bg-white/10 border border-white/10 transition-colors" data-id="element-437">
              <X className="w-5 h-5 text-gray-400 hover:text-white" data-id="element-438" />
            </button>
          </div>
        </div>

        {/* Content Area */}
        <div className="h-[calc(100%-88px)] overflow-y-auto p-8" data-id="element-439">
          {children}
        </div>
      </div>
    </div>;
}